import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CreateOrderCartDto, OrderCartDto, OrderCartServiceProxy, ProductDomainWarehouseInput, ProductDto, UserPermissionServiceProxy, WarehouseSelectListDto} from './../../../../../shared/service-proxies/service-proxies';


/**
 * Bu servis, sepete ürün ekleme, ürün çıkarma gibi islemleri yapar.
 * Ayrica kullanicinin talep yapailecegi depolar da bu servis uzerinden cekilir.
 * Sepete eklenip çıkarilan ürünler anlik olarak sunucu ile senkronize yonetilmektedir.
 */

@Injectable({
  providedIn: 'root'
})
export class CartService {

  userWarehouses$ : BehaviorSubject<WarehouseSelectListDto[]> = new BehaviorSubject<WarehouseSelectListDto[]>([]);
  sourceWarehouse :  WarehouseSelectListDto = new  WarehouseSelectListDto();

  /**
   * Sepetteki urun sayisidir.
   */
  productCount$ : BehaviorSubject<number> = new BehaviorSubject<number>(0);

  products$ : BehaviorSubject<ProductDto[]> = new BehaviorSubject<ProductDto[]>([]);

  constructor(
    private _orderCartService : OrderCartServiceProxy,
    private _userPermissionService: UserPermissionServiceProxy
  ) { 

    //Service instance alindiginde, sunucudan ogrenilir kullanicinin sepetindeki urun sayisi.
    this.getProductCount();

    this.loadProductInCart();

    //Urun listesindeki eklem ve cikarmalardan dolayi, sepetteki urun adedi miktarini dinler.
    this.products$.subscribe(res => {
      this.productCount$.next(res.length);
    });

    //Kullanıcının talep yapmaya yetkili oldugu depolarin listesi cekiliyor.
    this._userPermissionService.getFromRequestWarehouseByUserAuths(0)
            .subscribe(res => {
                this.userWarehouses$.next(res);
                console.log("DEPOLAR");
                console.log(res);

                if (res.length > 0){
                  this.sourceWarehouse = res[0];
                }
                
            });

  }


  /**
   * Sepetteki toplam urun sayisini sunucudan ogrenir.
   */
  getProductCount(): void{
      this._orderCartService.getProductCount()
                    .subscribe(res => {
                        this.productCount$.next(res);
                    });
  }

  /**
   * Kullanicinin sepete daha once eklemis oldugun urunleirn listesini verir. Ancak lite bir listedir.
   * Stok Adedi vb yoktur, sadece urun bilgilerini icerir.
   */
  loadProductInCart(): void {
    this._orderCartService.getProductsInCart()
                .subscribe(res => {
                    this.products$.next(res);
                });
  }

 
  /**
   * Sepete eklenen urun, clientside olarak ilgili listeye de eklenir.
   * Uygulama esnasinda, clientside olarak sepeti gostermek icin kullanilir.
   * @param product 
   */
  addProductToCart(product: ProductDto, onCallback: Function){
   

  
    //Server tarafinda, sepete ekleniyor.
   
    let cartItem = new CreateOrderCartDto();
    cartItem.productId = product.id ;
  
    this._orderCartService.create(cartItem).subscribe(res=>{

      //Client tarafinda da sepet listesine ekleniyor (Sepet tekrardan serverdan alinmiyor.)
      let list = this.products$.value ;
      list.push(product);
      this.products$.next(list);
  
      if (onCallback){
        onCallback();
      }

    });

    
  }

  /**
   * ClientSide olarak, sepetteki urun listesinden urun siler.
   * @param productId 
   */
  removeProductItem(productId: number){
    let list = this.products$.value ;
    
    //Server'daki sepetten de belirtilen urun silinir.
    this._orderCartService.removeProductInCart(productId).subscribe(res => {

          //Sunucu tarfinda sepetten cikarma islemleri yapildiktan sonra, client tarafinda da listeden cikarilir. (Liste tekrar sunucudan cekilemz)
         //Silinecek urunun, liste icindeki index numarasi bulunur.
          const itemIndex = list.findIndex(x=>x.id == productId);

          //bulunan index'deki item silinir.
          list.splice(itemIndex, 1);

          //Listeni guncel hali tekrar geri yuklenir.
          this.products$.next(list);

    });
   
  }


}
